import React, { useEffect, useState } from "react";

import Authenticated from "./Authenticated";
import UnAuthenticated from "./UnAuthenticated";

import { Loading } from "../Components/Common";

import { MainContext, AuthContext, LoadingContext } from "../Context";
import {
  TransactionGetTown,
  TransactionSettingGet,
} from "../Services/Transactions";
import { SettingType, TownType } from "../Structures";

const App = () => {
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("Token")
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [townList, setTownList] = useState<TownType[]>([]);
  const [setting, setSetting] = useState<SettingType>({
    first_image: "/imgs/landing/second.webp",
    second_image: "/imgs/landing/first.webp",
    third_image: "/imgs/landing/third.jpg",
    forth_image: "/imgs/landing/GrandMaster.png",
    blog_banner: "/imgs/baner.webp",
    coach_banner: "/imgs/baner.webp",
    event_banner: "/imgs/baner.webp",
    gallery_banner: "/imgs/baner.webp",
    rule_banner: "/imgs/baner.webp",
    first_title: "",
    second_title: "",
    about_banner: "",
    third_title: "",
    forth_title: "",
    cart_sheba: "",
    cart_number: "",
    account_number: "",
    owner_cart: "",
    officePhone: "",
    phone: "",
    workTime: "",
    address: "",
    email: "",
    copyright: "",
    telegramLink: "",
    whatsappLink: "",
    instagramLink: "",
    mapLink: "",
    is_loading: false,
  });

  // ================================================================

  useEffect(() => {
    setLoading(true);
    TransactionSettingGet()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          if (res.data) {
            setSetting(res.data);
          }
        }
      })
      .finally(() => setLoading(false));
    TransactionGetTown().then(({ data: res }) => {
      if (res.transaction_status) {
        setTownList(res.data || []);
      }
    });
  }, []);

  // ================================================================

  return (
    <AuthContext.Provider value={{ token, setToken }}>
      <MainContext.Provider
        value={{ setting, setSetting, townList, setTownList }}
      >
        <LoadingContext.Provider value={{ loading, setLoading }}>
          {token ? <Authenticated /> : <UnAuthenticated />}
          {loading ? <Loading /> : null}
        </LoadingContext.Provider>
      </MainContext.Provider>
    </AuthContext.Provider>
  );
};

export default App;
